export default "__VITE_ASSET__bqpuzmsU__"